import type { IMarket } from "~/types/event";

import { getMarketGroupId } from "./buildMarketGroups";

export const isConsensusAvailable = (
  markets: IMarket[],
  selections: string[]
): boolean => {
  const [selectedId] = selections;
  const targetMarket = markets.find(({ id }) => id === selectedId);

  if (!targetMarket) {
    return false;
  }

  const groupId = getMarketGroupId(targetMarket);

  return (
    markets.filter((market) => getMarketGroupId(market) === groupId).length > 1
  );
};
